var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"about"},[_c('h1',[_vm._v("This is an about page")]),_c('v-btn',{staticClass:"pink white--text",attrs:{"small":""}},[_c('v-icon',{attrs:{"left":""}},[_vm._v("fa fa-envelope")]),_c('span',[_vm._v("testing")])],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }